<template>
    <div class="view view--dasboard">
        <dashboard />
    </div>
</template>

<script>
    import dashboard from '../../components/Dashboard.vue';

    export default {
        components: {
            dashboard
        }
    }
</script>


// WEBPACK FOOTER //
// resources/assets/js/views/dashboard/Index.vue